import React from 'react';
// import { AppBar, UserMenu } from 'react-admin';
import { withStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';

const myCustomIconStyle = {
  avatar: {
    height: 30,
    width: 30
  }
};

const MyCustomIcon = withStyles(myCustomIconStyle)(({ classes }) => (
  <Avatar
    className={classes.avatar}
    src="https://marmelab.com/images/avatars/adrien.jpg"
  />
));

export default MyCustomIcon;



// WEBPACK FOOTER //
// ./src/components/MyCustomIcon.js